import { render, staticRenderFns } from "./minuteData.vue?vue&type=template&id=6021c072&scoped=true&"
import script from "./minuteData.vue?vue&type=script&lang=js&"
export * from "./minuteData.vue?vue&type=script&lang=js&"
import style0 from "./minuteData.vue?vue&type=style&index=0&id=6021c072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021c072",
  null
  
)

export default component.exports